function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import classnames from 'classnames';
import { flow } from 'lodash/fp';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import T from 'prop-types';
import Button from '../../components/button/Button';
import MembershipButton from '../../components/button/MembershipButton';
import { ACTIVITY_TYPES } from '../../constants/activity';
import { disableFilter, enableFilter, filterActivities } from '../../redux/actions/activity';
import routes from '../../routes/constants';
import text from '../../text';
import { isActivityFileDownload } from '../../utilities/activity';
import { filterByMultipleConditions } from '../../utilities/filter';
import { isDemoJob } from '../../utilities/job';
import SearchActivitiesInput from './SearchActivitiesInput';
var FILTERS = {
    ORDERS: 'orders',
    USERS: 'users',
    NOTES: 'notes',
    FILES: 'files',
    STATUSES: 'statuses',
    ALERTS: 'alerts'
};
var ActivityFilterControls = function(param) {
    var id = param.id, projectId = param.projectId, currentProject = param.currentProject;
    var dispatch = useDispatch();
    var history = useHistory();
    var _useSelector = useSelector(function(state) {
        return {
            projects: state.activity.projects,
            enabledFilters: state.activity.enabledFilters
        };
    }), projects = _useSelector.projects, enabledFilters = _useSelector.enabledFilters;
    var activityFilters = useMemo(function() {
        return [
            {
                name: FILTERS.ORDERS,
                predicate: function(activity) {
                    return activity.type === ACTIVITY_TYPES.order;
                },
                label: text('orders'),
                icon: 'shopping-cart'
            },
            {
                name: FILTERS.USERS,
                predicate: function(activity) {
                    return activity.type === ACTIVITY_TYPES.user;
                },
                label: text('users'),
                icon: 'user-outline'
            },
            {
                name: FILTERS.NOTES,
                predicate: function(activity) {
                    return activity.type === ACTIVITY_TYPES.note && !isActivityFileDownload(activity);
                },
                label: text('notes'),
                icon: 'speech'
            },
            {
                name: FILTERS.FILES,
                predicate: function(activity) {
                    return activity.type === ACTIVITY_TYPES.file;
                },
                label: text('files'),
                icon: 'clip'
            },
            {
                name: FILTERS.STATUSES,
                predicate: function(activity) {
                    return activity.type === ACTIVITY_TYPES.status;
                },
                label: text('statuses'),
                icon: 'circle'
            },
            {
                name: FILTERS.ALERTS,
                predicate: function(activity) {
                    return(/** need to check File downloaded from title for old activities prior
           *  saving File downlaoded activity as Alerts (larki type) */ activity.title.includes('File downloaded') || activity.type === ACTIVITY_TYPES.alert);
                },
                label: text('alerts'),
                icon: 'larki-icon'
            }
        ];
    }, []);
    var isEnabled = useCallback(function(enabledFilter) {
        return enabledFilters.includes(enabledFilter);
    }, [
        enabledFilters
    ]);
    var handleEnableFilter = function(filterName) {
        return dispatch(enableFilter(filterName));
    };
    var handleDisableFilter = function(filterName) {
        return dispatch(disableFilter(filterName));
    };
    var nonFilteredActivities = useMemo(function() {
        var _projects_projectId;
        return (_projects_projectId = projects[projectId]) === null || _projects_projectId === void 0 ? void 0 : _projects_projectId.nonFilteredActivities;
    }, [
        projectId,
        projects
    ]);
    var handleFilter = useCallback(function() {
        dispatch(filterActivities(enabledFilters.length !== 0 ? flow([
            filterByMultipleConditions(activityFilters.filter(function(activityFilter) {
                return enabledFilters.includes(activityFilter.name);
            }).map(function(activityFilter) {
                return activityFilter.predicate;
            }))
        ])(nonFilteredActivities) : nonFilteredActivities, projectId));
    }, [
        dispatch,
        enabledFilters,
        activityFilters,
        nonFilteredActivities,
        projectId
    ]);
    useEffect(function() {
        handleFilter();
    }, [
        handleFilter
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        id: id,
        className: "ActivityFilterControls"
    }, /*#__PURE__*/ React.createElement(SearchActivitiesInput, {
        projectId: projectId
    }), /*#__PURE__*/ React.createElement("div", {
        className: "ButtonGroup"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "m-0 mr-3"
    }, text('activityFilter'), ":"), activityFilters.map(function(filter, i) {
        return /*#__PURE__*/ React.createElement(Button, {
            key: i,
            className: classnames({
                enabled: isEnabled(filter.name)
            }),
            onClick: function() {
                return !isEnabled(filter.name) ? handleEnableFilter(filter.name) : handleDisableFilter(filter.name);
            },
            variant: "chip",
            icon: filter.icon
        }, filter.label);
    })), !isDemoJob(currentProject) && /*#__PURE__*/ React.createElement("div", {
        className: "right"
    }, /*#__PURE__*/ React.createElement(MembershipButton, {
        variant: "outline-primary"
    }), /*#__PURE__*/ React.createElement(Button, {
        id: "orderButton",
        variant: "primary",
        disabled: (currentProject === null || currentProject === void 0 ? void 0 : currentProject.status) === 'demo',
        onClick: function() {
            event.preventDefault();
            history.push(_object_spread({
                pathname: routes.mp.root
            }, !isDemoJob(currentProject) ? {
                search: "?projectId=".concat(currentProject === null || currentProject === void 0 ? void 0 : currentProject.projectId)
            } : {}));
        }
    }, text('order3DData'))));
};
ActivityFilterControls.propTypes = {
    id: T.oneOfType([
        T.string,
        T.number
    ]),
    projectId: T.oneOfType([
        T.string,
        T.number
    ]),
    currentProject: T.shape()
};
export default ActivityFilterControls;
